//Images
import youtube_logo from '../../assets/images/loghi/youtube.svg';
import starts from '../../assets/images/icons/stars.svg';
import './Navbar.css';

export default function Navbar() {
  return (
    <div
      className='relative flex flex-col items-center text-center navbar-container'
      id='navbar'
    >
      <img
        alt='Yotube Logo'
        className='noselect header_image_small w-auto'
        src={youtube_logo}
      />

      <span className='live-text mt-4'>Partecipa alla live</span>

      <h1 className='w-full text-4xl font-extrabold main-title'>
        Obiettivo Medicina, <span className='mobile-break'></span>Odontoiatria e
        Veterinaria
      </h1>

      <p className='mt-2'>
        Preparati ad affrontare gli esami del{' '}
        <span className='mobile-break'></span>semestre aperto
      </p>

      <img
        alt='Starts'
        className='noselect absolute stars-decoration'
        src={starts}
      />
    </div>
  );
}
